import { ExtendedProjectInfoDc } from "@evergis/api";
import { ProjectInfo } from "../../../interfaces/resourceInfo";

export const getProjectInfoFromExtendedProjectDc = (project: ExtendedProjectInfoDc): ProjectInfo => {
  if (project) {
    const layersCount = project.content && project.content.items && project.content.items.length;

    return {
      ...project,
      layersCount,
    };
  }

  return {};
};
